import { IonContent } from '@ionic/react';
import React from 'react';
import { useFormContext } from 'react-hook-form';

import { useAccount } from '@/hooks/useAccount';
import { amplitudeModule } from '@/modules/amplitude';
import { OnboardingFooter } from '@/pages/Onboarding/components/Footer';
import { OnboardingNavigation } from '@/pages/Onboarding/components/Navigation';
import { OnboardingPage } from '@/pages/Onboarding/components/Page';
import { useOnboarding } from '@/pages/Onboarding/context';
import { OwnAiTitle } from '@/pages/Onboarding/Layouts/OwnAI/components/Title';
import { HOW_OFTEN_REACH_OUT_OPTIONS } from '@/pages/Onboarding/options/HowOftenReachOut/HOW_OFTEN_REACH_OUT_OPTIONS';
import { getHowOftenReachOutTitleById } from '@/pages/Onboarding/options/HowOftenReachOut/utils/getHowOftenReachOut';
import { OnbOptionType } from '@/pages/Onboarding/types';
import { userService } from '@/services/user';
import { canLogEvents } from '@/utils/canLogEvents';

import {
  PurpleOptions,
  PurpleOptionItem,
} from '../../components/PurpleOptions';
import { LayoutDataType } from '../../types';

export const HowOftenReachOutScreen: React.FC = () => {
  const { user } = useAccount();

  React.useEffect(() => {
    if (user && canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'HowOftenReachOut',
      });
    }
  }, [user]);

  const { wizard } = useOnboarding();

  const form = useFormContext<LayoutDataType>();

  const howOften = form.watch('how_often_reach_out');

  const handleSelect = (
    option: OnbOptionType<LayoutDataType['how_often_reach_out']>,
  ) => {
    form.setValue('how_often_reach_out', option.id);
  };

  const handleNextStep = () => {
    const howOftenTitle = getHowOftenReachOutTitleById(howOften);
    userService.createOrUpdate({
      onboarding_data: {
        how_often_reach_out: howOftenTitle,
      },
    });
    wizard.nextStep();
  };

  return (
    <OnboardingPage background={'purple-gradient'}>
      <OnboardingNavigation />
      <OwnAiTitle>How Often Should He Reach Out?</OwnAiTitle>

      <IonContent>
        <PurpleOptions displayType="grid-with-icon">
          {HOW_OFTEN_REACH_OUT_OPTIONS.map((option) => (
            <PurpleOptionItem
              checked={howOften === option.id}
              control={form.control}
              option={option}
              name="how_often_reach_out"
              key={option.id}
              onChange={() => handleSelect(option)}
              displayType="grid-with-icon"
            />
          ))}
        </PurpleOptions>
      </IonContent>
      <OnboardingFooter
        onContinue={handleNextStep}
        buttonColor={'purple-gradient'}
        buttonRadius={'sm'}
        buttonSize={'large'}
        buttonClassName={'page-footer'}
        disabled={!howOften}
      />
    </OnboardingPage>
  );
};
